import moment from 'moment';

const styles = () => ({
  root: {
    fontSize: 15,
    color: '#A9B0B8',
    letterSpacing: '0',
    fontWeight: 400,
  },

  sub: {
    color: 'rgba(169,176,184,0.60)',
  },
});

function Timestamp({ classes, dateTime }) {
  let ts = moment(dateTime);

  let day = ts.format('MMM Do YYYY');
  let time = ts.format('h:mm:ss a');

  return (
    <time dateTime={dateTime} className={classes.root}>
      <span className={classes.sub}>on </span>
      <span>{day} </span>
      <span className={classes.sub}>at </span>
      <span>{time}</span>
    </time>
  );
}

Timestamp.propTypes = {
  dateTime: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Timestamp);
